import { call, put, takeLatest } from 'redux-saga/effects';
import { advisorActions as actions } from '.';
import { getFileKeyFromSignedUrl } from 'utils/filekey';
import {
  authenticatedPut,
  put as putrequest,
  authenticatedPost,
  authenticatedGet,
} from 'remote/api';
import { PayloadAction } from '@reduxjs/toolkit';

function* getSignedUrlSaga(file: File, fileType: string) {
  try {
    const formData = new FormData();
    formData.append('file_type', fileType);
    formData.append('files', file);

    const response = yield call(
      authenticatedPost,
      `${process.env.REACT_APP_API_URL}/advisor/files`,
      formData,
    );
    return response.data.url;
  } catch (error) {
    throw error;
  }
}

function* uploadFileSaga(file: File, fileType: string) {
  try {
    const signedUrl = yield call(getSignedUrlSaga, file, fileType);
    yield call(putrequest, signedUrl, file, {
      headers: {
        'Content-Type': file.type || 'application/octet-stream',
      },
    });

    const fileKey = getFileKeyFromSignedUrl(signedUrl);
    yield call(
      authenticatedGet,
      `${process.env.REACT_APP_API_URL}/advisor/files?file_key=${fileKey}`,
    );
  } catch (error) {
    throw error;
  }
}

export function* advisorSaga(action: PayloadAction<any>) {
  try {
    const { file, payload } = action.payload;

    if (file.brand.image != null) {
      yield call(uploadFileSaga, file.brand.image, file.brand.type);
    }

    yield call(uploadFileSaga, file.pan.image, file.pan.type);
    yield call(
      uploadFileSaga,
      file.proof_of_address.image,
      file.proof_of_address.type,
    );

    const response = yield call(
      authenticatedPut,
      `${process.env.REACT_APP_API_URL}/advisor/update-advisor-signup`,
      payload,
    );

    yield put(actions.createAdvisorSuccess(response.data));
  } catch (error: any) {
    yield put(
      actions.createAdvisorFailed(error.response?.data || error.message),
    );
  }
}

export function* watchupdateadvisorSaga() {
  yield takeLatest(actions.updateAdvisor.type, advisorSaga);
}
